import getConfig from 'next/config';

const {
  publicRuntimeConfig: { LAZY_LOAD_IMAGES_MINIMUM_COMPONENT_POSITION },
} = getConfig();

export const lazyLoadImages = (position: number) =>
  position >= LAZY_LOAD_IMAGES_MINIMUM_COMPONENT_POSITION;
